<template>
<div class="app">
  <app-navigation></app-navigation>
  <router-view></router-view>
  <app-footer></app-footer>
</div>
</template>

<script>
import Navigation from './components/Navigation.vue'
import Footer from './components/Footer.vue'
import search from './search'
import store from './store'
import JsonExcel from 'vue-json-excel'

export default {
  components: {
    'app-navigation': Navigation,
    'app-footer': Footer,
    'downloadExcel': JsonExcel
  },
  name: 'app',
  created() {
    store.dispatch('setupItems')
  }
}
</script>

<style>
@import './assets/css/m68.css';
</style>



// WEBPACK FOOTER //
// src/App.vue